import { render, staticRenderFns } from "./PPCCommentSection.vue?vue&type=template&id=12e10706&"
import script from "./PPCCommentSection.vue?vue&type=script&lang=js&"
export * from "./PPCCommentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports